var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.319 12.9075C16.7628 9.76899 16.542 5.22833 13.6569 2.34315C10.5327 -0.781049 5.46734 -0.781049 2.34315 2.34315C-0.781049 5.46734 -0.781049 10.5327 2.34315 13.6569C5.22833 16.542 9.76899 16.7628 12.9075 14.319C12.921 14.3343 12.9351 14.3493 12.9497 14.364L17.1924 18.6066C17.5829 18.9971 18.2161 18.9971 18.6066 18.6066C18.9971 18.2161 18.9971 17.5829 18.6066 17.1924L14.364 12.9497C14.3493 12.9351 14.3343 12.921 14.319 12.9075ZM12.2426 3.75736C14.5858 6.1005 14.5858 9.8995 12.2426 12.2426C9.8995 14.5858 6.1005 14.5858 3.75736 12.2426C1.41421 9.8995 1.41421 6.1005 3.75736 3.75736C6.1005 1.41421 9.8995 1.41421 12.2426 3.75736Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fd868b4b.svg";
export { ForwardRef as ReactComponent };